import { baseUrl } from "../../../boot/index";
import axios from "axios";

// Add Inventory
export const addInventorySolarPanel = async (formData) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/finance/app/v1/create-inventorySolarPanel`, formData, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    console.log({ error });
    throw error;
  }
};

// update Inventory
export const updateInventorySolarPanel = async (data) => {
  console.log({ data });
  const ROWID = data.ROWID;
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/finance/app/v1/update-inventorySolarPanel/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
// delete Inventory
export const deleteInventorySolarPanel = async (ROWID) => {
  console.log({ ROWID });
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/finance/app/v1/delete-inventorySolarPanel/${ROWID}`, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    console.log("Error is - ", error);
    throw error;
  }
};

// total count
export const countInventorySolarPanel = async (formData) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/finance/app/v1/count-inventorySolarPanel`, formData, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Get Inventory by ID
export const getInventorySolarPanelById = async (id) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/finance/app/v1/getbyid-inventorySolarPanel/${id}`, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
